;(function() {
  'use strict'

  Controller.$inject = ["$scope"];
  angular.module('app.survey').component('logicDebugger', {
    controller: Controller,
    templateUrl: 'logic-debugger.html',
    bindings: {
      survey: '<',
      logic: '<',
      loopKey: '<',
    },
  })

  /* @ngInject */
  function Controller($scope) {
    var ctrl = this

    ctrl.$onInit = onInit

    function onInit() {
      $scope.$watch(function() {
        ctrl.info = []

        // Apply all tag operations for this view to figure out the final
        // result (ultimately, which were added and which were removed)
        var currentViewIndex = ctrl.survey.getCurrentViewIndex()
        var tagsAdded = {}
        var tagsRemoved = {}
        ctrl.survey.tagOps.forEach(function(op) {
          if (op.givenByViewIndex !== currentViewIndex) return
          if (op.type === 'ADD') {
            tagsAdded[op.tag] = true
            delete tagsRemoved[op.tag]
          }
          if (op.type === 'REMOVE') {
            tagsRemoved[op.tag] = true
            delete tagsAdded[op.tag]
          }
        })
        tagsAdded = _.keys(tagsAdded)
        tagsRemoved = _.keys(tagsRemoved)
        if (tagsAdded.length) {
          ctrl.info.push('Respondent will be tagged: ' + tagsAdded.join(', '))
        }
        if (tagsRemoved.length) {
          ctrl.info.push(
            'Respondent will be untagged: ' + tagsRemoved.join(', ')
          )
        }

        // Find all other actions that are applied for the logic on this view.
        // We exclude all tag based actions because they are covered above.
        _.each(ctrl.logic, function(logic) {
          var triggered = ctrl.survey.allConditionsMet(
            logic.conditions,
            ctrl.loopKey
          )
          if (!triggered) return
          if (
            logic.isDisplay() &&
            (logic.targetsQuestion() || logic.targetsSection())
          ) {
            ctrl.info.push('Visible because one display logic condition is met')
          }
          if (logic.type === logic.Types.ACTION) {
            _.each(logic.actions, function(action) {
              var msg
              switch (action.type) {
                case action.Types.SUBMIT:
                  msg = 'Survey will submit.'
                  break
                case action.Types.EXIT:
                  msg = 'Survey will exit'
                  break
                case action.Types.QUALITYEXIT:
                  msg = 'Survey will quality exit'
                  break
                case action.Types.JUMP_TO_QUESTION:
                  if (!ctrl.survey.viewsByQuestionId[action.questionId]) {
                    break // fail silently and do nothing
                  }
                  msg =
                    'Survey will jump to Q' +
                    ctrl.survey.viewsByQuestionId[action.questionId].question
                      .number
                  if (action.loopKey) {
                    var loopVariable = getLoopVariable(
                      action.questionId,
                      action.loopKey
                    )
                    msg += ' <b>(' + loopVariable.label + ')</b>'
                  }
                  break
                case action.Types.JUMP_TO_SECTION:
                  if (!ctrl.survey.viewsBySectionId[action.sectionId]) {
                    break // fail silently and do nothing
                  }
                  msg =
                    'Survey will jump to S' +
                    ctrl.survey.viewsBySectionId[action.sectionId].section
                      .number
                  if (action.loopKey) {
                    var loopVariable = getLoopVariable(
                      action.sectionId,
                      action.loopKey
                    )
                    msg += ' <b>(' + loopVariable.label + ')</b>'
                  }
                  break
                case action.Types.JUMP_TO_FOLLOWUP: // DEPRECATED
                  msg = 'Survey will jump to Follow-Up'
                  break
                case action.Types.JUMP_TO_PROFILING: // DEPRECATED
                  msg = 'Survey will jump to Profiling'
                  break
                case action.Types.ADD_TO_LIST:
                  msg =
                    "Respondent will have '" +
                    action.listItem +
                    "' added to list '" +
                    action.list +
                    "'"
                  break
                case action.Types.HIDE_VIEW_GROUPS:
                  msg =
                    'Groups will be hidden: ' +
                    _.map(action.viewGroupIds, function(viewGroupId) {
                      return ctrl.survey.viewGroupsById[viewGroupId].name
                    }).join(', ')
                  break
                case action.Types.SET_VARIABLE:
                  msg =
                    "Variable '" +
                    action.variableKey +
                    "' will be set to '" +
                    action.variableValue +
                    "'"
                  break
              }
              if (msg) ctrl.info.push(msg)
            })
          }
        })
      })
    }

    function getLoopVariable(viewId, loopKey) {
      var viewGroup = _.find(ctrl.survey.viewGroupsById, function(group) {
        return group.viewIds.includes(viewId)
      })
      return _.find(viewGroup.allVisibleVariables, { id: loopKey })
    }
  }
})()
